import { render, staticRenderFns } from "./VcaDetail.vue?vue&type=template&id=c8aa356c&scoped=true"
import script from "./VcaDetail.vue?vue&type=script&lang=ts"
export * from "./VcaDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aa356c",
  null
  
)

export default component.exports